import React, { useState, useEffect, useRef } from "react";
import { Editor, EditorState, convertFromRaw, convertToRaw } from "draft-js";
import "draft-js/dist/Draft.css";
import { FlexGrid, Button } from "@albo-ui/core";
import { Divider } from "@mui/material";
import Toolbar from "./Toolbar";
import "./DraftEditor.css";

interface TextEditorProps {
    onConfirm: (content: any) => void;
    onCancel: () => void;
    value?: any;
}

const TextEditor: React.FC<TextEditorProps> = ({ value, onConfirm, onCancel }) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const editor = useRef(null);

    useEffect(() => {
        if (value) {
            try {
                const content = JSON.parse(value);
                const contentState = convertFromRaw(content);
                setEditorState(EditorState.createWithContent(contentState));
            } catch (error) {
                console.error("Error al cargar el contenido inicial:", error);
            }
        } else {
            focusEditor();
        }

    }, [value]);

    const styleMap: any = {
        HIGHLIGHT: {
            backgroundColor: "#b5f7a5",
        },
        UPPERCASE: {
            textTransform: "uppercase",
        },
        LOWERCASE: {
            textTransform: "lowercase",
        },
    };
    
    const myBlockStyleFn = (contentBlock) => {
        const type = contentBlock.getType();

        switch (type) {
            case "blockQuote":
                return "superFancyBlockquote";
            case "leftAlign":
                return "leftAlign";
            case "rightAlign":
                return "rightAlign";
            case "centerAlign":
                return "centerAlign";
            case "justifyAlign":
                return "justifyAlign";
            default:
                if(type.includes("header")){
                    return "header";
                }
                break;
        }
    };

    const focusEditor = () => {
        editor.current.focus();
    };

    const handleEditorChange = (state: EditorState) => {
        setEditorState(state);
    };

    const handleSave = () => {
        const contentState = editorState.getCurrentContent();
        const rawContent = JSON.stringify(convertToRaw(contentState));
        onConfirm({ content: rawContent });
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <>
        <div className="editor-wrapper" onClick={focusEditor}>
            <Toolbar
                editorState={editorState}
                setEditorState={setEditorState}
            />
            <Divider/>
            <div style={{padding: "10px", minHeight: 120}}>
                <Editor
                    ref={editor}
                    editorState={editorState}
                    onChange={handleEditorChange}
                    customStyleMap={styleMap}
                    blockStyleFn={myBlockStyleFn}
                    placeholder="Añadir descripción..."
                />
            </div>
        </div>
        <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 30 }}>
            <FlexGrid item>
                <Button onClick={handleCancel} buttonType="secondary" size="normal">
                    Cancelar
                </Button>
            </FlexGrid>
            <FlexGrid item>
                <Button onClick={handleSave} size="normal">
                    Aceptar
                </Button>
            </FlexGrid>
        </FlexGrid>
        </>
    );
};

export default TextEditor;
